export default {
  // Header Section
  "discover_your": "உங்கள்",
  "daily_horoscope": "தினசரி ராசிபலன்",
  "daily_cosmic_guidance": "தினசரி அண்ட வழிகாட்டுதல்",
  "daily_horoscope_description": "உங்கள் ராசியை அடிப்படையாகக் கொண்டு தனிப்பயன் தினசரி ராசிபலனைப் பெறுங்கள். காதல், தொழில், ஆரோக்கியம், நிதி ஆகியவற்றுக்கான நுண்ணறிவுகளுடன் தினசரி அதிர்ஷ்ட எண்கள், நிறங்கள் மற்றும் அண்ட வழிகாட்டுதல்கள் வழங்கப்படுகின்றன.",

  // Service Information
  "enter_details_for_horoscope": "தினசரி ராசிபலனுக்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "daily_horoscope_subscription": "தினசரி ராசிபலன் சந்தா",
  "service_price": "சேவை விலை",
  "daily_horoscope_subscription_note": "தனிப்பயன் தினசரி ராசிபலன் வழங்கலுக்கான மாதாந்திர சந்தா",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_cosmic_influence": "தனிப்பயன் முன்கணிப்புகளுக்காக உங்கள் பெயர் அண்ட அதிர்வுகளுடன் ஓசையும்",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_zodiac_sign": "உங்கள் ராசி மற்றும் தனிப்பயன் முன்கணிப்புகளை நிர்ணயிக்க இது அவசியம்",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் தினசரி ராசிபலன் தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Horoscope Features
  "daily_predictions": "தினசரி முன்கணிப்புகள்",
  "love_relationship_insights": "காதல் & உறவு நுண்ணறிவுகள்",
  "career_money_guidance": "தொழில் & நிதி வழிகாட்டுதல்",
  "health_wellness_tips": "ஆரோக்கிய & நல குறிப்புகள்",
  "lucky_numbers_colors": "அதிர்ஷ்ட எண்கள் & நிறங்கள்",
  "monthly_horoscope_bonus": "மாதாந்திர ராசிபலன் கூடுதல்",

  "what_you_get": "உங்கள் தினசரி ராசிபலனில் உள்ளவை",
  "personalized_daily_readings": "தனிப்பயன் தினசரி வாசிப்புகள்",
  "love_career_predictions": "காதல் & தொழில் முன்கணிப்புகள்",
  "daily_lucky_elements": "தினசரி அதிர்ஷ்ட கூறுகள்",
  "monthly_bonus_insights": "மாதாந்திர கூடுதல் நுண்ணறிவுகள்",

  // Actions & Buttons
  "subscribe_to_horoscope": "தினசரி ராசிபலனுக்கு சந்தா எடுக்கவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "சந்தா அமைக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "horoscope_subscription_processing": "உங்கள் தினசரி ராசிபலன் சந்தா இப்போது செயலில் உள்ளது. ஒவ்வொரு காலையிலும் தனிப்பயன் அண்ட வழிகாட்டுதலைப் பெற்று நம்பிக்கையுடன் நாளை தொடங்குங்கள்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "daily_delivery": "தினசரி விநியோகம்",
  "daily_horoscope_delivery_note": "உங்கள் தனிப்பயன் ராசிபலன் ஒவ்வொரு காலையிலும் கிடைக்கும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "தினசரி ராசிபலனை WhatsApp-ல் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "தினசரி ராசிபலன் அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் தினசரி ராசிபலன் தொகுப்பு",
  "daily_horoscope_reading": "தனிப்பயன் தினசரி ராசிபலன் வாசிப்பு",
  "love_relationship_daily_insights": "காதல் & உறவு தினசரி நுண்ணறிவுகள்",
  "career_financial_guidance": "தொழில் & நிதி தினசரி வழிகாட்டுதல்",
  "health_wellness_daily_tips": "ஆரோக்கிய & நல தினசரி குறிப்புகள்",
  "monthly_special_predictions": "மாதாந்திர சிறப்பு முன்கணிப்புகள்",

  // Visual Content
  "sample_daily_horoscope": "மாதிரி தினசரி ராசிபலன்",
  "leo_horoscope_today": "இன்றைய சிம்ம ராசிபலன்",
  "sample_horoscope_reading": "இன்று தனி வளர்ச்சி மற்றும் நிதி முன்னேற்றத்திற்கான வாய்ப்புகள் கிடைக்கும்",
  "sample_horoscope_preview": "அண்ட நுண்ணறிவுகளுடன் உங்கள் தனிப்பயன் தினசரி ராசிபலனின் முன்னோட்டம்",
  "zodiac_signs": "ராசிகள்",

  // Zodiac Sign Names
  "aries": "மேஷம்",
  "taurus": "ரிஷபம்",
  "gemini": "மிதுனம்",
  "cancer": "கடகம்",
  "leo": "சிம்மம்",
  "virgo": "கன்னி",
  "libra": "துலாம்",
  "scorpio": "விருச்சிகம்",
  "sagittarius": "தனுசு",
  "capricorn": "மகரம்",
  "aquarius": "கும்பம்",
  "pisces": "மீனம்",

  // Status & Processing
  "your_horoscope_status": "உங்கள் ராசிபலன் சந்தா நிலை",
  "processing_your_subscription": "உங்கள் சந்தா செயற்படுத்தப்படுகிறது",
  "subscription_processing_message": "உங்கள் தினசரி ராசிபலன் சந்தா செயற்படுத்தப்படுகிறது. நாளை காலை முதல் தனிப்பயன் அண்ட வழிகாட்டுதல் கிடைக்கும்.",
  "subscription_id": "சந்தா ஐடி",
  "status": "நிலை",
  "processing": "செயல்படுத்தப்படுகிறது",
  "active": "செயலில்",
  "confirmation_email_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "daily_whatsapp_updates": "தினசரி WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டது",
  "first_horoscope_tomorrow": "முதல் ராசிபலன் நாளை காலை வழங்கப்படும்",

  // Support & Contact
  "contact_support": "ராசிபலன் ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "subscription_failed": "சந்தா செயற்படுத்தல் தோல்வியடைந்தது. எங்கள் ஆதரவைத் தொடர்புகொள்ளுங்கள்.",

  // Daily Horoscope Categories
  "general_forecast": "பொது முன்னறிவிப்பு",
  "love_romance": "காதல் & ரோமాన్స్",
  "career_profession": "தொழில் & பணிமுறை",
  "health_wellbeing": "ஆரோக்கியம் & நலன்",
  "finance_money": "நிதி & பணம்",
  "family_relationships": "குடும்பம் & உறவுகள்",
  "travel_adventure": "பயணம் & சாகசம்",
  "spiritual_growth": "ஆன்மீக வளர்ச்சி",

  // Lucky Elements
  "lucky_number": "அதிர்ஷ்ட எண்",
  "lucky_color": "அதிர்ஷ்ட நிறம்",
  "lucky_time": "அதிர்ஷ்ட நேரம்",
  "lucky_direction": "அதிர்ஷ்ட திசை",
  "lucky_gemstone": "அதிர்ஷ்ட ரத்தினம்",
  "avoid_color": "தவிர்க்க வேண்டிய நிறம்",
  "avoid_time": "தவிர்க்க வேண்டிய நேரம்",

  // Daily Ratings
  "love_rating": "காதல் மதிப்பீடு",
  "career_rating": "தொழில் மதிப்பீடு",
  "health_rating": "ஆரோக்கிய மதிப்பீடு",
  "finance_rating": "நிதி மதிப்பீடு",
  "overall_rating": "மொத்த நாள் மதிப்பீடு",

  // Planetary Influences
  "planetary_influence": "கிரகத் தாக்கம்",
  "moon_phase": "சந்திரன் நிலை",
  "ruling_planet": "இன்றைய ஆட்சி கிரகம்",
  "planetary_transit": "முக்கிய கிரக கோச்சாரம்",
  "retrograde_alert": "வக்ர இயக்க எச்சரிக்கை",

  // Relationship Insights
  "single_horoscope": "தனிப்பட்ட காதல் முன்னறிவிப்பு",
  "relationship_horoscope": "உறவு முன்னறிவிப்பு",
  "marriage_horoscope": "திருமண முன்னறிவிப்பு",
  "friendship_forecast": "நட்பு முன்னறிவிப்பு",
  "family_harmony": "குடும்ப ஒற்றுமை",

  // Career Guidance
  "job_prospects": "வேலை வாய்ப்புகள்",
  "business_forecast": "வணிக முன்னறிவிப்பு",
  "investment_advice": "முதலீட்டு ஆலோசனை",
  "career_decisions": "தொழில் முடிவுகள்",
  "workplace_relationships": "பணியிட உறவுகள்",

  // Health Tips
  "physical_health": "உடல் ஆரோக்கியம்",
  "mental_wellbeing": "மனநலம்",
  "exercise_recommendation": "உடற்பயிற்சி பரிந்துரை",
  "diet_suggestion": "உணவு பரிந்துரை",
  "stress_management": "மனஅழுத்த மேலாண்மை",

  // Weekly & Monthly
  "weekly_overview": "வாராந்திர மேலோட்டம்",
  "monthly_highlights": "மாதாந்திர முக்கிய அம்சங்கள்",
  "seasonal_forecast": "஋து முன்னறிவிப்பு",
  "year_ahead": "வரவிருக்கும் ஆண்டின் முன்னோட்டம்",

  // Compatibility
  "compatible_signs_today": "இன்றைய இணக்கமான ராசிகள்",
  "challenging_signs": "சவாலாக இருக்கும் ராசிகள்",
  "best_match_today": "இன்றைய சிறந்த பொருத்தம்",
  "avoid_conflicts_with": "விவாதங்களை தவிர்க்க வேண்டிய ராசிகள்",

  // Remedies & Tips
  "daily_remedy": "இன்றைய பரிகாரம்",
  "positive_affirmation": "நன்மை உறுதிமொழி",
  "meditation_tip": "தியான குறிப்பு",
  "crystal_recommendation": "கிரிஸ்டல் பரிந்துரை",
  "mantra_for_today": "இன்றைய மந்திரம்",

  // Special Occasions
  "birthday_special": "பிறந்தநாள் சிறப்பு முன்னறிவிப்பு",
  "new_moon_influence": "அமாவாசைத் தாக்கம்",
  "full_moon_impact": "பௌர்ணமி தாக்கம்",
  "eclipse_effects": "கிரகணம் தாக்கங்கள்",
  "festival_predictions": "திருவிழா முன்னறிவிப்புகள்",

  // Subscription Management
  "subscription_active": "சந்தா செயலில்",
  "next_billing": "அடுத்த பில் தேதி",
  "cancel_subscription": "சந்தாவை ரத்து செய்யுங்கள்",
  "modify_subscription": "சந்தாவை மாற்றுங்கள்",
  "subscription_history": "சந்தா வரலாறு",

  // Personalization
  "customize_preferences": "விருப்பங்களை அமைக்கவும்",
  "delivery_time": "விருப்ப விநியோக நேரம்",
  "content_focus": "உள்ளடக்க கவனப்பகுதிகள்",
  "notification_settings": "அறிவிப்பு அமைப்புகள்",

  // Premium Features
  "premium_insights": "பிரீமியம் நுண்ணறிவுகள்",
  "detailed_analysis": "விரிவான பகுப்பாய்வு",
  "astrologer_notes": "ஜோதிட நிபுணரின் தனிப்பட்ட குறிப்புகள்",
  "priority_support": "முன்னுரிமை வாடிக்கையாளர் ஆதரவு"
};
